/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Вид для группы категорий второго уровня на странице категории первого уровня
   *
   * @param el {string} jQuery-селектор родительского элемента
   * @param itemEl {string} jQuery-селектор элемента категории
   */
  
  app.SubCategoriesView = app.CategoriesView.extend({
    
    el: '.backbone-categories-view',
    itemEl: '.category'
    
  });
})();

}.call(window));